import { render, staticRenderFns } from "./SessionCommentArea.vue?vue&type=template&id=5fb107fb&scoped=true&"
import script from "./SessionCommentArea.vue?vue&type=script&lang=js&"
export * from "./SessionCommentArea.vue?vue&type=script&lang=js&"
import style0 from "./SessionCommentArea.vue?vue&type=style&index=0&id=5fb107fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb107fb",
  null
  
)

export default component.exports